var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.856934 3.90991V19.2329C0.856934 20.3482 1.90503 21.1666 2.987 20.8961L7.71408 19.7143L11.4727 20.6539C10.5809 19.2237 9.85693 17.4487 9.85693 15.4286C9.85693 10.9314 13.5026 7.28571 17.9998 7.28571C19.2246 7.28571 20.3862 7.55614 21.4284 8.04055V3.05277C21.4284 1.93749 20.3802 1.11917 19.2984 1.38966L14.5712 2.57143L7.71408 0.857143L2.15544 2.24679C1.3923 2.43759 0.856934 3.12327 0.856934 3.90991Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 2.57143V6.85714",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71387 0.857143V19.7143",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4284 6.85714V3.05277C21.4284 1.9375 20.3802 1.11917 19.2984 1.38966L14.5712 2.57143L7.71408 0.857143L2.15544 2.24679C1.3923 2.43759 0.856934 3.12327 0.856934 3.90991V19.2329C0.856934 20.3482 1.90503 21.1666 2.987 20.8961L7.71408 19.7143L10.6998 20.4607",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 15.4286C23.1426 19.7143 17.9998 23.1429 17.9998 23.1429C17.9998 23.1429 12.8569 19.7143 12.8569 15.4286C12.8569 12.5883 15.1595 10.2857 17.9998 10.2857C20.8402 10.2857 23.1426 12.5883 23.1426 15.4286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 15.4286C23.1426 19.7143 17.9998 23.1429 17.9998 23.1429C17.9998 23.1429 12.8569 19.7143 12.8569 15.4286C12.8569 12.5883 15.1595 10.2857 17.9998 10.2857C20.8402 10.2857 23.1426 12.5883 23.1426 15.4286Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 16.2857C18.473 16.2857 18.8569 15.902 18.8569 15.4286C18.8569 14.9552 18.473 14.5714 17.9997 14.5714C17.5264 14.5714 17.1426 14.9552 17.1426 15.4286C17.1426 15.902 17.5264 16.2857 17.9997 16.2857Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4dd665c31c2625abd7463c926a14f5a5.svg";
export { ForwardRef as ReactComponent };